export const AUDITC_BAND0_LIMIT = 2.5;
export const AUDITC_BAND1_LIMIT = 4.5;
export const AUDITC_BAND2_LIMIT = 6.5;
export const AUDITC_BAND3_LIMIT = 9.5;
